import { InfoCard, Link } from '@backstage/core-components';
import { Grid, Link as ExternalLink, Theme, Typography, makeStyles } from '@material-ui/core';
import BugReportOutlinedIcon from '@material-ui/icons/BugReportOutlined';
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { ReactNode } from 'react';

const PLATFORM_TEAM_PATH = '/catalog/default/group/it_azure_platformteam_group';
const SERVICENOW_SELF_SERVICE_URL =
  'https://cae.service-now.com/esc?id=my_requests';
const SERVICENOW_REPORT_ISSUE_URL =
  'https://cae.service-now.com/esc?id=sc_cat_item&sys_id=e77a3d484737de109c4bd8ca216d4333';

const useStyles = makeStyles((theme: Theme) => ({
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    height: '100%',
    padding: theme.spacing(1.5, 2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  icon: {
    fontSize: 28,
    flexShrink: 0,
  },
  title: {
    fontWeight: 700,
  },
}));

const HelpItem = ({ icon, title, children }: { icon: ReactNode; title: string; children: ReactNode }) => {
  const classes = useStyles();
  return (
    <div className={classes.item}>
      {icon}
      <div>
        <Typography variant="subtitle2" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {children}
        </Typography>
      </div>
    </div>
  );
};

/** Compact Platform Engineering help card with the ServiceNow entry points. */
export const HelpCard = () => {
  const classes = useStyles();
  return (
    <InfoCard title="Need help?" variant="fullHeight">
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <HelpItem icon={<HelpOutlineIcon color="primary" className={classes.icon} />} title="Request assistance">
            Use the{' '}
            <ExternalLink href={SERVICENOW_SELF_SERVICE_URL} target="_blank" rel="noopener noreferrer">
              My ServiceNow tickets
            </ExternalLink>
          </HelpItem>
        </Grid>
        <Grid item xs={12} md={4}>
          <HelpItem icon={<BugReportOutlinedIcon color="primary" className={classes.icon} />} title="Found an issue?">
            <ExternalLink href={SERVICENOW_REPORT_ISSUE_URL} target="_blank" rel="noopener noreferrer">
              Report it on ServiceNow
            </ExternalLink>
          </HelpItem>
        </Grid>
        <Grid item xs={12} md={4}>
          <HelpItem icon={<GroupOutlinedIcon color="primary" className={classes.icon} />} title="Who we are">
            Meet the <Link to={PLATFORM_TEAM_PATH}>Platform Engineering Team</Link>
          </HelpItem>
        </Grid>
      </Grid>
    </InfoCard>
  );
};
